import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'signin-sign_in_password_submit-click';
/**
 * This will be used for record password submission on sign-in flow.

There will be a parameter or two.
[&quot;INCORRECT&quot;] -&gt; means submitted password is not correct
[&quot;CORRECT&quot;]
[&quot;CORRECT&quot;, &quot;MFA_PHONE&quot;] -&gt; For the MFA flow, after putting the code, will be asked to put the number again.
[&quot;CORRECT&quot;, &quot;MFA_EMAIL&quot;]
There will also be incorrect combination with MFA
*/
export function trackSigninSignInPasswordSubmitClick(Correctness, MFA2) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { Correctness, MFA2 },
    });
}
